let _csrfToken = null;

export function getCsrfToken() {
  if (!_csrfToken) {
    const elm = document.querySelector('meta[name=csrf-token]')
    _csrfToken ||= elm.getAttribute('content')
  }
  return _csrfToken
}
